import React from 'react';
import { BaseFilterProps, DropDownFilter } from 'framework/list';
import WasteStatusDropdown from '../inputs/WasteStatusDropdown';

const WasteStatusFilter = ({ source, ...props }: BaseFilterProps & { label: string }) => {
  return (
    <DropDownFilter {...props} source={source}>
      <WasteStatusDropdown source={source} />
    </DropDownFilter>
  );
};

export default WasteStatusFilter;
